import React, { useMemo } from "react"
import contributionTrainIcon from "../../../assets/images/contribution-train-icon.svg"
import heartIconAlt from "../../../assets/images/pt-heart-icon-alt.svg"



const ContributionTrain = ({ trainText, target, raised, raisedOnline, raisedOffline, cost, targetType, progress = "10%" }) => {
  // TODO: due to proggress arrange position of "provided-meals" -> left | center | right
  const numberFormat = useMemo(() => new Intl.NumberFormat(), [])
  const totalRaised = raised + raisedOnline + raisedOffline
  const trainIconStyle = {
    left: (((totalRaised / cost) * 100) / (target / cost)) > 50 ? '-68px' : '-38px'
  }
  const providedMealsStyle = {
    transform: (((totalRaised / cost) * 100) / (target / cost)) > 50 ? 'translate(-100%, 100%)' : 'translate(-30%, 100%)'
  }
  return (
    <section className="soundingLouder-contributionTrain">
      <div className="hiddenOverflow">
        <div className="contributionTrain-top">
          <h5 className="track-funding">track your funding</h5>
          <h5 className="target-meals">Target: {numberFormat.format(Math.floor(target / cost))} {targetType}</h5>
        </div>
      </div>

      <div className="train-lines">
        <div className="train-line-behind" style={{ width: (((totalRaised / cost) * 100) / (target / cost)) + '%' }}></div>
        <div className="train-line-ahead">
          <div className="line-overlay"></div>
          <img
            src={contributionTrainIcon}
            className="train-icon"
            style={trainIconStyle}
            alt="contribution train icon"
          />
          <h5 className="provided-meals" style={providedMealsStyle}>{trainText} {numberFormat.format(Math.floor(totalRaised / cost))}</h5>
          <img src={heartIconAlt} className="heart-icon" alt="heart icon" />
        </div>
      </div>
    </section>
  )
}

export default ContributionTrain
